<section>
    <h1>EcoEHS Admin Tool</h1>
    <mat-tab-group [selectedIndex]="activeTabIndex" (selectedTabChange)="onTabChange($event)">
        @for (tab of tabs; track tab)
        {
            <mat-tab [label]="tab.label">
                @if (tab.view === pilotTenantsView)
                {
                    <app-multi-select
                        label="Pilot tenant statuses"
                        [selectedItemsList]="selectedPilotStatuses"
                        [itemsList]="pilotStatusOptions"
                        (listValuesChange)="onPilotStatusesChange($event)">
                    </app-multi-select>
                }
                @if (tab.view === pilotTenantsView && pilotStatusesError)
                {
                    <p data-qa-id="pilot-statuses-error" class="pilot-statuses-error">{{ pilotStatusesError }}</p>
                }
                @if (apps && !loading)
                {
                    <table data-qa-id="home-table-recent-apps" class="recent-apps">
                        <thead>
                        <tr>
                            <th></th>
                            <th>Tenant Slug</th>
                            <th>Tenant Name</th>
                            <th>Tenant Status</th>
                            <th>Environment</th>
                            <th>Provisioned On</th>
                            <th>Provisioned By</th>
                        </tr>
                        </thead>
                        <tbody>
                            @for (a of apps; track a.TenantId)
                            {
                                <tr [ngStyle]="getBackground(a)" [class.disabled]="!a.HasAccess">
                                    <td>
                                        @if (!a.ProvisioningComplete)
                                        {
                                            <a mat-button
                                                class="mat-primary"
                                                data-qa-id="home-link-provision"
                                                [routerLink]="['/tenant', a.TenantId,'airsweb','new']"
                                                routerLinkActive="active">
                                            Provision
                                            </a>
                                        }
                                        @if (a.ProvisioningComplete && a.HasAccess)
                                        {
                                            <a mat-button
                                                class="mat-primary"
                                                data-qa-id="home-link-manage"
                                                [routerLink]="['/tenant', a.TenantId, a.MagicName]"
                                                routerLinkActive="active"
                                                [attr.id]="'manageTenant' + a.Tenant">
                                            Manage
                                            </a>
                                        }
                                        @if (!a.HasAccess)
                                        {
                                            <a class="disabled mat-primary mat-button">Manage</a>
                                        }
                                    </td>
                                    <td>{{a.Tenant}}</td>
                                    <td>{{a.TenantName}}</td>
                                    <td class="tenant-status" [ngClass]="a.TenantStatus">{{a.TenantStatus}}</td>
                                    <td>{{a.EnvironmentName}}</td>
                                    <td>{{a.ProvisioningCompletedOn | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
                                    <td>{{a.Username}}</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                }
                @if (loading)
                {
                    <p>Loading...</p>
                }
                @if (!loading && apps?.length === 0)
                {
                    <p>No tenants found.</p>
                }
                @if (!loading && totalPages > 1)
                {
                    <div class="pagination">
                        <span class="pagination-summary">{{pageRangeStart}}-{{pageRangeEnd}} of {{totalCount}}</span>
                        <button mat-icon-button [disabled]="currentPage === 1" (click)="goToPage(1)" matTooltip="First page" aria-label="First page">
                            <mat-icon>first_page</mat-icon>
                        </button>
                        <button mat-icon-button [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)" matTooltip="Previous page" aria-label="Previous page">
                            <mat-icon>chevron_left</mat-icon>
                        </button>
                        <button mat-icon-button [disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)" matTooltip="Next page" aria-label="Next page">
                            <mat-icon>chevron_right</mat-icon>
                        </button>
                        <button mat-icon-button [disabled]="currentPage === totalPages" (click)="goToPage(totalPages)" matTooltip="Last page" aria-label="Last page">
                            <mat-icon>last_page</mat-icon>
                        </button>
                    </div>
                }
            </mat-tab>
        }
    </mat-tab-group>
</section>
